import { render } from "./ArrowUp.vue?vue&type=template&id=dbe4e6f4&scoped=true"
const script = {}

import "./ArrowUp.vue?vue&type=style&index=0&id=dbe4e6f4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbe4e6f4"]])

export default __exports__